export class Door {
    sid: string;
    name: string;
    pin_closed: number;
    pin_opened: number;
    pin_toggle: number;
    pin_buttontoggle: number;
    is_deleted: boolean;
    toggle_delay: number;
    toggle_enabled: boolean;
    buttontoggle_enabled: boolean;


    public static has_pin_closed = (door: Door) => {
        return Door._has_pin (door.pin_closed);
    }
    public static has_pin_opened = (door: Door) => {
        return Door._has_pin (door.pin_opened);
    }
    public static has_pin_toggle = (door: Door) => {
        return Door._has_pin (door.pin_toggle) && door.toggle_enabled;
    }
    public static has_pin_buttontoggle = (door: Door) => {
        return Door._has_pin(door.pin_buttontoggle) && door.buttontoggle_enabled;
    }

    private static _has_pin = (pin?: number) => {
        return pin !== undefined && pin >= 0;
    }
}


// WEBPACK FOOTER //
// ./src/app/model/door.ts